// Technologist names arrive with credentials attached ("Jane Doe, CNIM, R.EP.T.").
// The client wants only the name shown, so everything from the first comma on
// is dropped. Display-side only: stored names and backend lookups keep the
// full value.
export function techDisplayName(name) {
  if (!name) return name;
  const i = String(name).indexOf(",");
  return i === -1 ? name : String(name).slice(0, i).trim();
}
